import { ComponentProps, createContext, ElementType } from "react";
import { twMerge } from "tailwind-merge";
import Button from "./Button";

type IconButtonContextType = { iconClassName: string };

export const IconButtonContext = createContext<
  IconButtonContextType | undefined
>(undefined);

export default function IconButton<E extends ElementType = "button">({
  as,
  className,
  children,
  ...props
}: ComponentProps<typeof Button<E>>) {
  return (
    <Button
      as={as as ElementType}
      className={twMerge(
        "inline-flex justify-center items-center rounded-full p-1.5",
        className
      )}
      {...props}
    >
      <IconButtonContext.Provider value={{ iconClassName: "size-6" }}>
        {children}
      </IconButtonContext.Provider>
    </Button>
  );
}
